import { Injectable } from '@angular/core';
import { ApiEntityStore } from '@core/api/api-entity-store';
import { Partner } from '@core/models/partner.model';
import { EntityState, StoreConfig } from '@datorama/akita';

export interface PartnerState extends EntityState<Partner> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'partnersOverview', resettable: true })
export class PartnerStore extends ApiEntityStore<PartnerState> {
  constructor() {
    super();
  }
}
